import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import ls from 'localstorage-slim';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { APP_PERMISSIONS } from 'src/app/app.constants';
import { AppState } from 'src/app/store';
import {
  AccountStatementsFiltersModel,
  selectActiveAccount
} from '../../../store/selectors/accounts/accounts.selectors';
ls.config.encrypt = true;
@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  privileges: string[] | undefined = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  selectedAccount$: Observable<AccountStatementsFiltersModel>;

  constructor(private store: Store<AppState>) {
    this.selectedAccount$ = this.store.select(selectActiveAccount);
    this.selectedAccount$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: value => {
        this.privileges = value.selectedAccount ? value.selectedAccount?.privileges : ['READ_CARDS', 'BLOCK_CARDS'];
      }
    });
  }

  hasPrivilege(privilege: any): boolean {
    return this.privileges?.includes(privilege) /* &&
      ls.get(SUPER_USER) === false */
      ? /* ||
      ls.get(SUPER_USER) === true */
        true
      : false;
  }

  hasAppPermission(permission: any): boolean {
    return JSON.parse(localStorage.getItem(APP_PERMISSIONS) || '{}')!.includes(
      permission
    )
      ? true
      : false;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
